import React from 'react';
import { Carousel } from '@yme/atoms/carousel';
import { GridWrapper } from '@yme/atoms/grid';
import { GAP_BETWEEN_ITEMS } from '@yme/molecules/cards';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { CARD_ITEM_SETTINGS } from './constants';
export function Features(props) {
    const { commonProps, dataTestId, HeaderCarouselComponent, carouselProps, isRightToLeft } = props;
    const { getterSize, items, CardComponent, labels, setCounts, carouselConfig, isDotsPanelVisible, isDotsFixed, } = carouselProps;
    return (React.createElement(GridWrapper, null,
        React.createElement(FlexWrapper, { flexDirection: "column", isRightToLeft: isRightToLeft },
            React.createElement(FlexWrapper, { flexDirection: "column" },
                HeaderCarouselComponent && HeaderCarouselComponent,
                React.createElement(Carousel
                // common props for functionality of carousel
                , { ...commonProps, dataTestId: dataTestId, 
                    // Other Carousel props
                    getterSize: getterSize || GAP_BETWEEN_ITEMS, items: items, ChildComponent: CardComponent, labels: labels, setCounts: setCounts, carouselConfig: carouselConfig || CARD_ITEM_SETTINGS, isDotsPanelVisible: isDotsPanelVisible, isDotsFixed: isDotsFixed })))));
}
Features.displayName = 'Features_Organism';
